import request from "@/utils/request";

// 查询场馆步道列表
export const getAlameda = (data) => {
  return request({
    url: "/api/alameda/list",
    method: "get",
    params: data,
  });
};
// 查询实验室数据
export const getLabList = (data) => {
  return request({
    url: "/api/lab/list",
    method: "get",
    params: data,
  });
};
// 查询实验室详情
export const getLabDetail = (data) => {
  return request({
    url: "/api/lab/fetch",
    method: "get",
    params: data,
  });
};
// 查询专家
export const getExpertList = (data) => {
  return request({
    url: "/api/expert/list",
    method: "get",
    params: data,
  });
};
// 查询专家详情
export const getExpertDetail = (data) => {
  return request({
    url: "/api/expert/fetch",
    method: "get",
    params: data,
  });
};
// 查询友情链接数据
export const getPartnerList = (data) => {
  return request({
    url: "/api/partner/list",
    method: "get",
    params: data,
  });
};
// 文章查询
export const getArticleList = (data) => {
  return request({
    url: "/api/article/list",
    method: "get",
    params: data,
  });
};
// 首页认证数据
export const getAuthData = () => {
  return request({
    url: "/api/info/authData",
    method: "get"
  });
};
// 首页地图
export const getMapData = (params) => {
  return request({
    url: "/api/info/map",
    method: "get",
    params
  });
};